<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="main-wizard">
    <ul class="wizard">
      <li
        v-for="(step, index) in getSteps()"
        :key="index"
        class="wizard-list list"
        :class="[
          { active: index == activeIndex },
          { passed: index < activeIndex },
        ]"
      >
        <span class="listlink" v-html="step"></span>
        <!--<a href="#" data-toggle="tab" aria-expanded="false" class="listlink" v-html="step"></a>-->
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "MainWizard",
  props: {
    activeIndex: { type: Number, default: null },
    type: { type: String, default: "" },
  },
  methods: {
    getSteps: function () {
      let steps = [];
      switch (this.type) {
        case "entry":
          steps = [
            '<span class="nmbr">1. <br class="-pcnone"><span class="-spnone">お客さま情報の</span>ご入力</span>',
            '<span class="nmbr">2. <br class="-pcnone"><span class="-spnone">入力内容の</span>ご確認</span>',
            '<span class="nmbr">3. <br class="-pcnone"><span class="-spnone">口座の</span>ご登録</span>',
            '<span class="nmbr">4. <br class="-pcnone">完了</span>',
          ];
          break;
        case "en2":
          steps = [
            '<span class="nmbr">1. <br class="-pcnone"><span class="-spnone">お客さま情報の</span>ご入力</span>',
            '<span class="nmbr">2. <br class="-pcnone"><span class="-spnone">入力内容の</span>ご確認</span>',
            '<span class="nmbr">3. <br class="-pcnone"><span class="-spnone">書類の</span>アップロード</span>',
            '<span class="nmbr">4. <br class="-pcnone">完了</span>',
          ];
          break;
        case "secret":
          steps = [
            '<span class="nmbr">1. <br class="-pcnone">ご入力</span>',
            '<span class="nmbr">2. <br class="-pcnone"><span class="-spnone">入力内容の</span>ご確認</span>',
            '<span class="nmbr">3. <br class="-pcnone">設定完了</span>',
          ];
          break;
        case "income":
          steps = [
            '<span class="nmbr">1. <br class="-pcnone"><span class="-spnone">証明書の</span>ご選択</span>',
            '<span class="nmbr">2. <br class="-pcnone"><span class="-spnone">ファイルのご選択</span><span class="-pcnone">ファイル選択</span></span>',
            '<span class="nmbr">3. <br class="-pcnone">アップロード</span>',
            '<span class="nmbr">4. <br class="-pcnone">完了</span>',
          ];
          break;
        case "useridentity":
          steps = [
            '<span class="nmbr">1. <br class="-pcnone"><span class="-spnone">書類の</span>ご選択</span>',
            '<span class="nmbr">2. <br class="-pcnone"><span class="-spnone">ファイルのご選択</span><span class="-pcnone">ファイル選択</span></span>',
            '<span class="nmbr">3. <br class="-pcnone">アップロード</span>',
            '<span class="nmbr">4. <br class="-pcnone">完了</span>',
          ];
          break;
        case "mb":
          steps = [
            '<span class="nmbr">1. <br class="-pcnone">金額入力</span>',
            '<span class="nmbr">2. <br class="-pcnone"><span class="-spnone">入力内容の</span>ご確認</span>',
            '<span class="nmbr">3. <br class="-pcnone"><span class="-spnone">お申し込み</span>完了</span>',
          ];
          break;
        case "userinfo":
          steps = [
            '<span class="nmbr">1. <br class="-pcnone"><span class="-spnone">お客さま情報の</span>ご入力</span>',
            '<span class="nmbr">2. <br class="-pcnone"><span class="-spnone">入力内容の</span>ご確認</span>',
            '<span class="nmbr">3. <br class="-pcnone">完了</span>',
          ];
          break;
        case "useremploy":
          steps = [
            '<span class="nmbr">1. <br class="-pcnone"><span class="-spnone">お勤め先情報の</span>ご入力</span>',
            '<span class="nmbr">2. <br class="-pcnone"><span class="-spnone">入力内容の</span>ご確認</span>',
            '<span class="nmbr">3. <br class="-pcnone">完了</span>',
          ];
          break;
        case "useremail":
          steps = [
            '<span class="nmbr">1. <br class="-pcnone"><span class="-spnone">メールアドレス情報の</span>ご入力</span>',
            '<span class="nmbr">2. <br class="-pcnone"><span class="-spnone">入力内容の</span>ご確認</span>',
            '<span class="nmbr">3. <br class="-pcnone">完了</span>',
          ];
          break;
        case "userpassword":
          steps = [
            '<span class="nmbr">1. <br class="-pcnone">暗証番号再入力</span>',
            '<span class="nmbr">2. <br class="-pcnone">再設定完了</span>',
          ];
          break;
        case "localid":
          steps = [
            '<span class="nmbr">1. <br class="-pcnone"><span class="-pcnone">本人確認</span><span class="-spnone">ご本人さま確認</span></span>',
            '<span class="nmbr">2. <br class="-pcnone"><span class="-pcnone">情報入力</span><span class="-spnone">お客さま情報のご入力</span></span>',
            '<span class="nmbr">3. <br class="-pcnone">ご確認</span>',
            '<span class="nmbr">4. <br class="-pcnone">完了</span>',
          ];
          break;
        case "phone":
          steps = [
            '<span class="nmbr">1. <br class="-pcnone"><span class="-pcnone">ご入力</span><span class="-spnone">電話番号のご入力</span></span>',
            '<span class="nmbr">2. <br class="-pcnone"><span class="-pcnone">ご確認</span><span class="-spnone">入力内容のご確認</span></span>',
            '<span class="nmbr">3. <br class="-pcnone">完了</span>',
          ];
          break;
        default:
          steps = [];
      }
      return steps;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.main-wizard {
  .wizard {
    border: 1px solid $secondary;
    border-radius: 10px;
    overflow: hidden;
    background-color: transparent;
    padding: 0;
    margin: 0;
    width: 100%;
    border-radius: 10px;
    clear: both;
    @include mq-up(md) {
      @include flex(flex, space-between, center, row, nowrap);
    }
    @include mq-down(md) {
      display: flex;
      justify-content: center;
      overflow: hidden;
    }
    .wizard-list {
      text-align: center;
      flex-grow: 1;
      @include mq-down(md) {
        height: 62px;
        line-height: 16px;
      }
      @include mq-up(md) {
        width: 100%;
      }
      &.list {
        position: relative;
        padding: 0;
        float: left;
        @include mq-down(md) {
          background-color: $light;
        }
        &.passed {
          color: #aaa;
        }
        &.active {
          > .listlink {
            @include mq-down(md) {
              height: 100%;
            }
            @include mq-up(md) {
              padding-top: 23px;
              padding-bottom: 23px;
            }
          }
        }
        &.active > * {
          color: $white !important;
          background-color: $primary !important;
          border-color: $primary !important;
          border-bottom: none !important;
          .nmbr {
            color: $white !important;
          }
        }
        > .listlink {
          opacity: 1;
          font-size: 12px;
          display: block;
          @include mq-up(md) {
            line-height: 16px;
            background-color: $light;
            font-size: 16px;
          }
          @include mq-down(md) {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            margin-right: -13px;
          }
          @media screen and (max-width: 320px) {
            font-size: 10px;
          }
          > .nmbr {
            display: inline-block;
            margin: 0 auto;
            border-radius: 50%;
            color: $black;
            text-align: center;
            @include mq-down(md) {
              margin-left: 20%;
            }
          }

          :deep(.nmbr) {
            z-index: 100;
          }
        }
        > .listlink:hover {
          color: $black;
          background-color: $light;
          border-color: $light;
        }
      }
      &.list::after {
        content: "";
        position: absolute;
        top: 8px;
        right: -5px;
        height: 0;
        width: 0;
        border: 23px solid transparent;
        border-right-width: 0;
        @include mq-up(md) {
          right: -22px;
        }
      }
      &.list::after {
        z-index: 1;
        -webkit-transform: translateX(1px);
        -moz-transform: translateX(1px);
        -ms-transform: translateX(1px);
        -o-transform: translateX(1px);
        transform: translateX(1px);
        margin: 0;
        width: 46px;
        height: 46px;
        border-bottom-right-radius: 5px;
        transform: rotate(-45deg);
        border-top: 1px solid transparent;
        border-left: 0px solid transparent;
        border-right: 1px solid $secondary;
        border-bottom: 1px solid $secondary;
        // background: linear-gradient(-45deg, $light 50%, transparent 50%);
        background: $light;
        @include mq-down(md) {
          top: 13px;
          right: -18px;
          width: 36px;
          height: 36px;
          transform: rotate(-45deg)
            skew(calc((90deg - 120deg) / 2), calc((90deg - 120deg) / 2));
        }
        @include mq-up(md) {
          background: linear-gradient(-45deg, $light 50%, transparent 50%);
        }
      }
      &.list > *::after {
        z-index: 2;
        border-left-color: inherit;
      }
      &.list.active::after {
        z-index: 1;
        -webkit-transform: translateX(1px);
        -moz-transform: translateX(1px);
        -ms-transform: translateX(1px);
        -o-transform: translateX(1px);
        transform: translateX(1px);
        margin: 0;
        width: 46px;
        height: 46px;
        border-bottom-right-radius: 5px;
        transform: rotate(-45deg);
        background: linear-gradient(-45deg, $primary 50%, transparent 50%);
        @include mq-down(md) {
          border: 1px solid $primary;
          border-top: none;
          border-left: none;
          background-color: $primary;
          top: 14px;
          right: -18px;
          width: 35px;
          height: 35px;
          transform: rotate(-45deg)
            skew(calc((90deg - 120deg) / 2), calc((90deg - 120deg) / 2));
        }
        @include mq-up(md) {
          background: linear-gradient(-45deg, $primary 50%, transparent 50%);
        }
      }
      &.list.before::after {
        @include mq-down(md) {
          background: linear-gradient(-45deg, $light 50%, transparent 50%);
        }
      }
      &.list:last-child {
        margin-right: 0;
        > .listlink {
          @include mq-down(md) {
            margin-left: 0px;
          }
          > .nmbr {
            @include mq-down(md) {
              margin-left: 0px;
            }
          }
        }
      }
      &.list:last-child a:after,
      &.list:last-child:after {
        display: none;
      }
      &.list:last-child a {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }
      &.list:nth-of-type(1) > a {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }
      &.list > * {
        position: relative;
        border-color: $light;
        @include mq-up(md) {
          padding-top: 23px;
          padding-bottom: 23px;
        }
      }
      &.list::after:last-child {
        border: none;
      }
    }
  }
}
</style>
